import { ComponentPropsWithoutRef } from 'react';
import { cn } from '@zep/utils';
const Root = (props: ComponentPropsWithoutRef<'ul'>) => {
  const {
    className,
    children
  } = props;
  return <ul className={cn('flex flex-col gap-[14px]', className)} data-sentry-component="Root" data-sentry-source-file="FeatureListItem.tsx">{children}</ul>;
};
const List = (props: ComponentPropsWithoutRef<'li'>) => {
  const {
    className,
    children
  } = props;
  return <li className={cn('flex items-center gap-[8px]', className)} data-sentry-component="List" data-sentry-source-file="FeatureListItem.tsx">{children}</li>;
};
const Icon = (props: ComponentPropsWithoutRef<'div'>) => {
  const {
    className,
    children
  } = props;
  return <div className={cn('w-[16px]', className)} data-sentry-component="Icon" data-sentry-source-file="FeatureListItem.tsx">{children}</div>;
};
const Text = (props: ComponentPropsWithoutRef<'span'>) => {
  const {
    className,
    children
  } = props;
  return <span className={cn('text-body-2-m text-[13px] font-[500] text-[#27262ECC]', className)} data-sentry-component="Text" data-sentry-source-file="FeatureListItem.tsx">
      {children}
    </span>;
};
export const FeatureListItem = {
  Root,
  List,
  Icon,
  Text
};